import { FC } from 'react'
import { Box, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { Tooltip } from 'packages/eid-ui'
import { Instructions } from 'containers/ViewAllCsvInbox/CsvInboxDetail/Instructions'
import { useTranslation } from 'react-i18next'
import Button from './Button'

export interface IResourceListingInfoIconProps {
    attribute: any
    data: any
    isCardView?: boolean
}

const ListViewRoot = styled(Box)({
    display: 'flex',
    marginTop: '-1rem',
})

const CardViewRoot = styled(Box)({
    position: 'relative',
    width: '100%',
})

const IconWrapper = styled(Box)({
    position: 'absolute',
})

export const ResourceListingInfoIcon: FC<IResourceListingInfoIconProps> = (
    props,
) => {
    const { t } = useTranslation()

    const { data, isCardView } = props

    const getTooltipTitle = () => t('Common_MoreInfo')
    return (
        <>
            {data && data.instructions && (
                <Box component={isCardView ? CardViewRoot : ListViewRoot}>
                    <Instructions
                        title={data.friendlyName}
                        instructions={data.instructions}
                        button={(onClick: any) => {
                            return !isCardView ? (
                                <Tooltip title={getTooltipTitle()}>
                                    <IconWrapper onClick={() => onClick(true)}>
                                        <Icon
                                            name="Info"
                                            color="#8b909a"
                                            width="2rem"
                                            height="2rem"
                                        ></Icon>
                                    </IconWrapper>
                                </Tooltip>
                            ) : (
                                <Button
                                    title={t('Common_MoreInfo')}
                                    onClick={() => onClick(true)}
                                ></Button>
                            )
                        }}
                    />
                </Box>
            )}
        </>
    )
}
